import { createAction } from 'redux-actions';

import { IS_LOADING, SET_COMPATIBILITY_MAPPING } from '../reducers/compatibility';
import { fetchCompatibilityMapping } from '../../firebase/compatibility';

const setLoading = createAction(IS_LOADING)
const setCompatibilityMapping = createAction(SET_COMPATIBILITY_MAPPING)

export const getCompatibilityMapping = () => async dispatch => {
    dispatch(setLoading(true));

    try {
        const compatibilityMapping = await fetchCompatibilityMapping();

        dispatch(setCompatibilityMapping({ compatibilityMapping }));
    } catch (error) {
        //TODO handle errors
    } finally {
        dispatch(setLoading(false))
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/compatibility.js